import { createSlice } from '@reduxjs/toolkit';
import { AssetFilterSelection } from '../screens/AssetManagement/components/AssetFilterModal/components/AssetFilterItem';

export type AssetsFilterState = {
  filters: AssetFilterSelection[],
  saved: boolean,
}

const initialState: AssetsFilterState = {
  filters: [],
  saved: false,
};

const assetsFilterSlice = createSlice({
  name: 'assetsFilter',
  initialState,
  reducers: {
    updateAssetsFilter(state: AssetsFilterState, action: { payload: AssetFilterSelection[] }) {
      state.filters = action.payload;
    },
    resetAllAssetFilters(state: AssetsFilterState) {
      state.filters = [];
      state.saved = false;
    },
    setAssetsFilterSaved(state: AssetsFilterState, action: { payload: boolean }) {
      state.saved = action.payload;
    },
  },
});

export const {
  updateAssetsFilter, resetAllAssetFilters, setAssetsFilterSaved,
} = assetsFilterSlice.actions;

export default assetsFilterSlice.reducer;
